import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import ARadio from "./hark/radio";
import React from "react";
import { getPrefixCls } from "../config";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Radio(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var prefixCls = getPrefixCls("radio");
  return /*#__PURE__*/_jsx(ARadio, _objectSpread({
    prefixCls: prefixCls
  }, props));
}